module.exports = __webpack_public_path__ + "assets/content_copy_FILL0_wght400_GRAD0_opsz24.svg";